import { useState } from 'react'
import { cover } from '../../utility/constant/helper.constant'
import {
  TSidewallFront,
  TSidewallLeft,
  TSidewallRight,
} from '../../utility/type/terraceCover.type'

/**
 * Values and methods are used by the context API
 * @returns states being used to manipulate the scene
 */

export const useStateSidewall = () => {
  const [sidewallRight, setSidewallRight] = useState<TSidewallRight>(
    cover.terraceCover.sidewallRight
  )
  const [sidewallLeft, setSidewallLeft] = useState<TSidewallLeft>(
    cover.terraceCover.sidewallLeft
  )
  const [sidewallFront, setSidewallFront] = useState<TSidewallFront>(
    cover.terraceCover.sidewallFront
  )

  const onHandleSidewallRight = (value: TSidewallRight) => {
    setSidewallRight(value)
  }

  const onHandleSidewallLeft = (value: TSidewallLeft) => {
    setSidewallLeft(value)
  }

  const onHandleSidewallFront = (value: TSidewallFront) => {
    setSidewallFront(value)
  }

  return {
    sidewall: {
      sidewallRight,
      sidewallLeft,
      sidewallFront,
    },

    sidewallMethod: {
      onHandleSidewallRight,
      onHandleSidewallLeft,
      onHandleSidewallFront,
    },
  }
}
